// Сбой облачного провайдера Яндекс: попап на входе, блок в ЛК, неактивные витрина и загрузка чеков.
// Когда сервисы восстановят — поставить false.
export const SERVICE_OUTAGE = true;
